import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION3: PdfComponent = {
  type: 'section',
  id: 's1s3',
  title: '3. Data Processors',
  content: [
    {
      type: 'bulletList',
      id: 's1s3bullets',
      bulletType: 'number',
      content: [
        {
          copy: {
            type: 'altText',
            id: '3dp',
            content: [
              'The parties agree that the following persons may act as ',
              'Data Processors',
              ' when delivering and/or using systems relevant to the performance of this Agreement:',
            ],
            boldFirst: false,
          },
          sublist: {
            bulletType: 'dot',
            content: [
              {
                copy: 'Kanda',
              },
            ],
          },
        },
      ],
      prefix: '3',
    },
  ],
};
